import { CAMERA_MOVIE_TYPE } from "@/config/const";

const COMMON_LANGUAGE = {
  ja: {
    Play: "再生",
    Pause: "一時停止",
    Mute: "ミュート",
    Unmute: "ミュート解除",
    "Current Time": "現在の時間",
    "Duration Time": "再生時間",
    "Remaining Time": "残り時間",
    Fullscreen: "全画面",
    "Exit Fullscreen": "全画面解除",
    "Playback Rate": "再生速度",
    Subtitles: "字幕",
    Captions: "キャプション",
    Chapters: "チャプター",
    Descriptions: "説明",
    "Audio Track": "オーディオトラック",
    Quality: "画質",
    "Download Video": "ビデオをダウンロード",
    "The media could not be loaded, either because the server or network failed or because the format is not supported.":
      "映像の読み込みに失敗しました。ネットワークまたは形式に問題がある可能性があります。",
    "Playback cannot continue. No available working or supported playlists.":
      "映像が取得できません。自動的に再接続していますので、しばらくお待ちください。",
  },
};

const cameraConnectingMessages = {
  1: {
    msg: "カメラに接続中...",
  },
  2: {
    msg: "レーダーに接続中...",
  },
  4: {
    msg: "カメラに接続中...",
  },
  5: {
    msg: "レーダーに接続中...",
  },
  8: {
    msg: "カメラに接続中...",
  },
};

const cameraErrorMessages = {
  1: {
    msg: "カメラに接続できませんでした",
  },
  2: {
    msg: "レーダーに接続できませんでした",
  },
  4: {
    msg: "カメラに接続できませんでした",
  },
  5: {
    msg: "レーダーに接続できませんでした",
  },
  8: {
    msg: "カメラに接続できませんでした",
  },
};
const playerOptions = {
  1: {
    aspectRatio: "16:9",
    autoplay: true,
    muted: true,
    preload: "auto",
    fullscreen: false,
    bigPlayButton: true,
    flash: { vhs: { withCredentials: false } },
    html5: { vhs: { withCredentials: false } },
    language: "ja",
    languages: {
      ja: {
        ...COMMON_LANGUAGE.ja,
        // "The media could not be loaded, either because the server or network failed or because the format is not supported.":
        //   "ネットワークに障害が発生したか、カメラが停止したため、再生できません",
      },
    },
    errorDisplay: true,
    inactivityTimeout: 2000,
    controls: true,
    controlBar: {
      children: ["customControlSpacer", "liveDisplay", "fullscreenToggle"],
    },
  },
  2: {
    fluid: true,
    autoplay: true,
    muted: true,
    preload: "auto",
    fullscreen: false,
    bigPlayButton: true,
    flash: { vhs: { withCredentials: false } },
    html5: { vhs: { withCredentials: false } },
    language: "ja",
    languages: {
      ja: {
        ...COMMON_LANGUAGE.ja,
        // "The media could not be loaded, either because the server or network failed or because the format is not supported.":
        //   "ネットワークに障害が発生したか、レーダーが停止したため、再生できません",
      },
    },
    errorDisplay: true,
    inactivityTimeout: 2000,
    controls: true,
    controlBar: {
      children: ["customControlSpacer", "liveDisplay", "fullscreenToggle"],
    },
  },
  4: {
    aspectRatio: "16:9",
    autoplay: true,
    muted: true,
    preload: "auto",
    fullscreen: true,
    bigPlayButton: false,
    flash: { vhs: { withCredentials: false } },
    html5: {
      vhs: {
        overrideNative: true,
        withCredentials: false,
      },
    },
    errorDisplay: true,
    language: "ja",
    languages: {
      ja: {
        ...COMMON_LANGUAGE.ja,
        // "The media could not be loaded, either because the server or network failed or because the format is not supported.":
        //   "映像の読み込みに失敗しました。ネットワークまたは形式に問題がある可能性があります。",
      },
    },
    inactivityTimeout: 2000,
    controls: true,
    controlBar: {
      children: ["customControlSpacer", "liveDisplay", "fullscreenToggle"],
    },
  },
  5: {
    fluid: true,
    muted: true,
    preload: "auto",
    fullscreen: false,
    bigPlayButton: false,
    flash: { vhs: { withCredentials: false } },
    html5: { vhs: { withCredentials: false } },
    language: "ja",
    languages: {
      ja: {
        ...COMMON_LANGUAGE.ja,
        // "The media could not be loaded, either because the server or network failed or because the format is not supported.":
        //   "ネットワークに障害が発生したか、レーダーが停止したため、再生できません",
      },
    },
    errorDisplay: true,
    inactivityTimeout: 2000,
    controls: true,
    controlBar: {
      children: ["customControlSpacer", "liveDisplay", "fullscreenToggle"],
    },
  },
  6: {
    aspectRatio: "16:9",
    autoplay: false,
    muted: true,
    preload: "auto",
    fullscreen: false,
    bigPlayButton: false,
    flash: { vhs: { withCredentials: false } },
    html5: { vhs: { withCredentials: false } },
    language: "ja",
    languages: {
      ja: {
        ...COMMON_LANGUAGE.ja,
        // "The media could not be loaded, either because the server or network failed or because the format is not supported.":
        //   "ネットワークに障害が発生したか、カメラが停止したため、再生できません",
      },
    },
    errorDisplay: true,
    inactivityTimeout: 2000,
    controls: true,
    controlBar: {
      children: ["customControlSpacer", "liveDisplay", "fullscreenToggle"],
    },
  },
  8: {
    aspectRatio: "16:9",
    fluid: true,
    autoplay: true,
    muted: true,
    preload: "auto",
    fullscreen: true,
    bigPlayButton: false,
    flash: { vhs: { withCredentials: false } },
    html5: {
      vhs: {
        overrideNative: true,
        withCredentials: false,
      },
    },
    errorDisplay: true,
    language: "ja",
    languages: {
      ja: {
        ...COMMON_LANGUAGE.ja,
        // "The media could not be loaded, either because the server or network failed or because the format is not supported.":
        //   "映像の読み込みに失敗しました。ネットワークまたは形式に問題がある可能性があります。",
      },
    },
    inactivityTimeout: 2000,
    controls: true,
    controlBar: {
      children: ["customControlSpacer", "liveDisplay", "fullscreenToggle"],
    },
  },
  9: {
    aspectRatio: "16:9",
    fluid: true,
    autoplay: true,
    muted: true,
    preload: "auto",
    fullscreen: true,
    bigPlayButton: false,
    flash: { vhs: { withCredentials: false } },
    html5: {
      vhs: {
        overrideNative: true,
        withCredentials: false,
      },
    },
    errorDisplay: true,
    language: "ja",
    languages: {
      ja: {
        ...COMMON_LANGUAGE.ja,
        // "The media could not be loaded, either because the server or network failed or because the format is not supported.":
        //   "映像の読み込みに失敗しました。ネットワークまたは形式に問題がある可能性があります。",
      },
    },
    inactivityTimeout: 2000,
    controls: true,
    controlBar: {
      children: ["customControlSpacer", "liveDisplay", "fullscreenToggle"],
    },
  },
};

export default {
  data() {
    return {
      CAMERA_MOVIE_TYPE: CAMERA_MOVIE_TYPE,
    };
  },
  methods: {
    getPlayerOption(type) {
      return playerOptions[type] || {};
    },
    getCameraConnectingMessage(type) {
      return (
        (cameraConnectingMessages[type] &&
          cameraConnectingMessages[type].msg) ||
        ""
      );
    },
    getCameraErrorMessage(type) {
      return (cameraErrorMessages[type] && cameraErrorMessages[type].msg) || "";
    },
  },
};
